import { buildShippingLabelViewModel } from "@/modules/chat-tools/domain/build-shipping-label";
import type { BatchLabelItem } from "@/modules/chat-tools/domain/luck-printer/print-batch-labels";
import type { ShopSettingsDTO } from "@/modules/chat-tools/domain/contracts";
import { ordersApi } from "@/modules/orders/presentation/api/client";

export type BatchPrintOrderRef = {
  id: string;
  orderNumber: string;
  customerName: string;
};

export async function loadBatchLabelItems(
  orders: BatchPrintOrderRef[],
  shopSettings: ShopSettingsDTO,
  onProgress?: (message: string) => void,
): Promise<{ items: BatchLabelItem[]; loadFailures: BatchPrintOrderRef[] }> {
  const items: BatchLabelItem[] = [];
  const loadFailures: BatchPrintOrderRef[] = [];

  for (let index = 0; index < orders.length; index++) {
    const orderRef = orders[index];
    if (!orderRef) continue;

    onProgress?.(
      `ກຳລັງໂຫຼດ ${orderRef.orderNumber} (${index + 1}/${orders.length})`,
    );

    try {
      const order = await ordersApi.get(orderRef.id);
      items.push({
        orderId: order.id,
        orderNumber: order.orderNumber,
        label: buildShippingLabelViewModel(order, shopSettings),
      });
    } catch {
      loadFailures.push(orderRef);
    }
  }

  return { items, loadFailures };
}
